import {Vue} from 'ui.vue';
import './style.scss';

import AppTemplate from './component/app.vue';

Vue.component("CitrusPagination", AppTemplate);
